import { OVERVIEW_MODAL_PLAYLIST_PARAM } from './overviewConsts';
export const PRE_ASSESSMENT_URL_FRAGMENT = 'pre-assessment';
export const getLessonBaseUrl = (lessonId, suffix) => {
  return `/lessons/${lessonId}${suffix ? `/${suffix}` : ''}`;
};
export const getLessonPreAssessmentUrl = lessonId => getLessonBaseUrl(lessonId, PRE_ASSESSMENT_URL_FRAGMENT);
export const getTrackLessonPreAssessmentUrl = (trackId, lessonId) => `/tracks/${trackId}/${lessonId}/${PRE_ASSESSMENT_URL_FRAGMENT}`;
export const getOverviewModalEnrollUrl = ({
  language,
  playlistId,
  to
}) => {
  const searchParams = new URLSearchParams();
  if (language) {
    searchParams.set('language', language);
  }
  if (playlistId) {
    searchParams.set(OVERVIEW_MODAL_PLAYLIST_PARAM, playlistId.toString());
  }
  const search = searchParams.toString();
  return search ? `${to}?${search}` : to;
};